import React, { useEffect, useState, Fragment } from 'react';
import { motion } from 'framer-motion';
import { ActionButton } from './ActionButton';
function useCountdown() {
  const [seconds, setSeconds] = useState(23 * 3600 + 34 * 60 + 39);
  useEffect(() => {
    const timer = window.setInterval(() => setSeconds(value => Math.max(0, value - 1)), 1000);
    return () => window.clearInterval(timer);
  }, []);
  return [Math.floor(seconds / 3600), Math.floor(seconds % 3600 / 60), seconds % 60].map(value => String(value).padStart(2, '0'));
}
interface PricingProps {
  showAnchor?: boolean;
  description?: string;
}
export function Pricing({
  showAnchor = false,
  description
}: PricingProps) {
  const [hours, minutes, seconds] = useCountdown();
  return <section id={showAnchor ? 'pricing' : undefined} className="bg-surface" data-id="element-112" data-mp="20rjvhwshf4uk">
      <div className="bg-urgency-surface px-4 py-16 sm:py-20" data-id="element-113" data-mp="3h6boaatjie4e">
        <div className="mx-auto max-w-4xl text-center" data-id="element-114" data-mp="3c8a2hi4qc0p8">
          <h2 className="font-display text-xl font-bold sm:text-2xl" data-id="element-115" data-mp="3c7ry1y7wyg68">
            💰 PRECIO DE LANZAMIENTO — CIERRA EN:
          </h2>
          <div className="mt-6 flex justify-center gap-3 sm:gap-6" role="timer" aria-label={`${hours} horas, ${minutes} minutos, ${seconds} segundos`} data-id="element-116" data-mp="4t5mxgphvg05">
            {[[hours, 'HS'], [minutes, 'MIN'], [seconds, 'SEG']].map(([value, label], index) => <Fragment key={label} data-id="element-117" data-mp="eqab1m2whljl" data-mpi={index}>
                <div data-id="element-118" data-mp="eqjzv6c7lmnp">
                  <p className="font-display text-5xl font-bold tabular-nums text-danger sm:text-7xl" data-id="element-119" data-mp="3d8z47xrngvi9">
                    {value}
                  </p>
                  <p className="text-xs tracking-spaced text-foreground-subtle" data-id="element-120" data-mp="3i8tv41bfdl3b">
                    {label}
                  </p>
                </div>
                {index < 2 && <span className="pt-2 font-display text-4xl text-danger sm:text-6xl" aria-hidden="true" data-id="element-121" data-mp="3rydf5aavjkzr">
                    :
                  </span>}
              </Fragment>)}
          </div>
          <p className="mt-6 text-foreground-subtle" data-id="element-122" data-mp="2zhat9xt50d2v">
            Después sube. <b className="text-foreground" data-id="element-123" data-mp="2zfg4g8eqw0ti">No vuelve.</b>
          </p>
          <div className="mx-auto mt-5 max-w-md rounded-xl border border-danger/20 bg-canvas p-4 text-left" data-id="element-124" data-mp="2rfjuj9slggki">
            <div className="flex justify-between text-sm font-medium text-danger-soft" data-id="element-125" data-mp="2mh8l3067o82t">
              <span data-id="element-126" data-mp="315czvt257zgb">Precio de lanzamiento</span>
              <span data-id="element-127" data-mp="2w7l8r19bohd6">Quedan pocos</span>
            </div>
            <div className="mt-3 h-2.5 overflow-hidden rounded-full bg-track" data-id="element-128" data-mp="2w839ob6xjjrf">
              <div className="h-full w-[80%] rounded-full bg-danger" data-id="element-129" data-mp="28j1wkan5jkft" />
            </div>
            <p className="mt-2 text-right text-xs text-foreground-faint" data-id="element-130" data-mp="23jpctyrkuthg">
              Cupos disponibles al precio de lanzamiento
            </p>
          </div>
        </div>
      </div>
      <div className="px-4 py-16 sm:py-24" data-id="element-131" data-mp="2dgk9sd87cltm">
        <div className="mx-auto max-w-2xl" data-id="element-132" data-mp="2dfintdpneex4">
          <h2 className="text-center font-display text-3xl font-bold sm:text-4xl" data-id="element-133" data-mp="3tv3ee37ot3cy">
            🌿 TU PROTOCOLO COMPLETO
          </h2>
          <motion.div initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mt-8 rounded-3xl border-2 border-primary bg-canvas p-6 shadow-featured sm:p-9" data-id="element-134" data-mp="3ovgzlpc7nf21">
            <div className="flex flex-col gap-4 sm:flex-row sm:justify-between" data-id="element-135" data-mp="3nfv3y9tes9pd">
              <div data-id="element-136" data-mp="3rgeyd5mlkz7t">
                <h3 className="font-display text-lg font-bold text-primary-soft" data-id="element-137" data-mp="3rfwx1ul2vut1">
                  PROTOCOLO CALMA APLICADA
                </h3>
                <p className="mt-1 text-sm text-foreground-subtle" data-id="element-138" data-mp="j2y8rtg058fy">
                  4 Volúmenes + 5 Bonos · Acceso inmediato
                </p>
                {description && <p className="mt-3 max-w-xs text-sm leading-relaxed text-foreground-muted" data-id="element-139" data-mp="a7i5ymx9riy8">
                    {description}
                  </p>}
              </div>
              <div className="shrink-0 sm:text-right" data-id="element-140" data-mp="11zzg3kx13kn2">
                <p className="text-xs uppercase tracking-wider text-foreground-faint" data-id="element-141" data-mp="11yg1rzuxnjnx">
                  Precio original
                </p>
                <p className="text-foreground-faint line-through" data-id="element-142" data-mp="3f78vcmg73tje">$65.000</p>
                <p className="mt-2 text-xs uppercase tracking-wider text-primary-soft/70" data-id="element-143" data-mp="3f55uf7di8fzw">
                  Precio lanzamiento
                </p>
                <p className="font-display text-4xl font-bold text-primary-soft" data-id="element-144" data-mp="35adw21c3lp42">
                  $19.990
                </p>
                <p className="text-xs text-foreground-subtle" data-id="element-145" data-mp="319k8j92kicbp">ARS</p>
              </div>
            </div>
          </motion.div>
          <ActionButton className="mt-7" showTrust data-id="element-146" data-mp="3syx3yfr8jzvm">
            🌿 QUIERO MI PROTOCOLO DE CALMA
          </ActionButton>
        </div>
      </div>
    </section>;
}